<section class="error-notification" [@isHidden]="hidden">
  <div [translate]="messageKey"></div>
  <button class="button button_stroked button_contrast button_size-sm error-notification__button"
          translate="component.errorNotification.closeButton"
          *ngIf="showCloseButton"
          (click)="closeNotification()">
  </button>
</section>
